import styled from "styled-components"

import { minWidth } from "utils"

import AccordionItem from "components/accordion-item"

export const Container = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 5rem;
`

export const Wrapper = styled.div`
  margin: 2rem 2rem 3rem;
  width: 100%;

  ${minWidth.tablet`
    max-width: 72.5rem;
    margin: 0 auto 4rem;
  `}
`

export const Heading = styled.h2`
  margin: 0 0 1rem 0;
  font-weight: 600;
  padding-bottom: 1rem;
  border-bottom: 0.3rem solid #f3f3f3;
  display: flex;
  justify-content: flex-start;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.4rem;
  line-height: normal;

  ${minWidth.tablet`
    margin-left: auto;
  `}
`

export const Item = styled(AccordionItem)`
  width: 100%;

  ${minWidth.tablet`
    summary {
      padding-right: 5rem;
    }
  `}
`

export const ProcessList = styled.div`
  max-width: 72.5rem;
  margin: 3rem 2rem;
  border-bottom: 0.3rem solid #f3f3f3;

  ${minWidth.tablet`
    margin: 3rem auto;
  `}
`

export const ProcessWrapper = styled.div`
  margin: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`

export const ProcessItem = styled.div`
  width: 100%;
  padding: 1rem;

  ${minWidth.tablet`
    width: 50%;
    padding-bottom: 0;
  `}
`

export const ProcessItemContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 2rem;

  ${minWidth.tablet`
    padding-bottom: 0.5rem;
  `}
`

export const ProcessItemHeader = styled.h4`
  padding-left: 1.5rem;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.4rem;
  color: #222222;
  font-weight: 600;
`

export const ProcessItemBody = styled.div`
  padding-left: 3.5rem;
  font-size: 1.8rem;
  a {
    text-decoration: underline;
    color: #b5471f;
    font-weight: medium;
  }
`
